import { inject } from '@angular/core';

import { PanelService } from '@connect-services/client/services/panel.service';
import { AbstractComponent } from '@connect-services/src/app/abstract.component';

export abstract class AbstractPanelComponent extends AbstractComponent {
    protected readonly panelService = inject(PanelService);

    public override destroyCallback(): void {
        this.panelService.closePanel();
    }
}
